import { render } from "./CompanyCreate.vue?vue&type=template&id=086c5eee"
import script from "./CompanyCreate.vue?vue&type=script&lang=js"
export * from "./CompanyCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__